var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"tabs__wrap"},[_c('div',{ref:"slider",staticClass:"tabs__slider"}),_vm._l((_vm.tabs),function(ref){
var label = ref.label;
var name = ref.name;
return _c('div',{key:name,staticClass:"tabs__tab",class:{ 'tabs__tab--active': name === _vm.value },on:{"click":function($event){return _vm.onTabClick(name)}}},[_vm._v(" "+_vm._s(label)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }